
export default function MapSearchBarDirective() {
    return {
        template: require('./map-search-bar.component.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            enabled: '=',
            loading: '=',
            placeholder: '@',
            onClickButton: '&',
            onClickFilters: '&',
            ngModel: '=',
            ngChange: '=',
            showingFilters: '=',
            filterCount: '='
        }
    };
}
